const overallData = {
  // axiosUrl: 'http://test-api.ccspeed.cn/app' // 请求的访问前缀
  axiosUrl: 'https://prd-api.ccspeed.cn/app'
}
export default overallData
